import {
  Box,
  Flex,
  Heading,
  HStack,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import Footer from 'components/footer/FooterAuth';
import {
  MdOutlineDirectionsCar,
  MdOutlineFolderOpen,
  MdOutlinePhotoLibrary,
} from 'react-icons/md';

function AuthIllustration(props) {
  const { children } = props;
  const panelBg = useColorModeValue(
    'rgba(255,255,255,0.78)',
    'rgba(16, 23, 40, 0.82)',
  );
  const panelBorder = useColorModeValue(
    'rgba(162, 176, 210, 0.18)',
    'rgba(255,255,255,0.08)',
  );
  const heroOverlay = useColorModeValue(
    'linear-gradient(145deg, rgba(17, 24, 39, 0.28), rgba(111, 66, 193, 0.18))',
    'linear-gradient(145deg, rgba(7, 12, 24, 0.38), rgba(111, 66, 193, 0.18))',
  );

  return (
    <Flex
      position="relative"
      minH="100vh"
      direction={{ base: 'column', xl: 'row' }}
    >
      <Flex
        flex="1"
        minH="100vh"
        px={{ base: '20px', md: '32px', xl: '44px' }}
        py={{ base: '28px', md: '32px' }}
        justifyContent="space-between"
        direction="column"
      >
        {/* <NavLink
          to='/admin'
          style={() => ({
            width: 'fit-content',
          })}>
          <Flex align='center' px='6px' py='4px' w='fit-content'>
            <Icon as={FaChevronLeft} me='10px' h='12px' w='8px' color='secondaryGray.600' />
            <Text ms='0px' fontSize='sm' color='secondaryGray.600'>
              Back to dashboard
            </Text>
          </Flex>
        </NavLink> */}

        <Flex flex="1" align="center" py={{ base: '18px', xl: '40px' }}>
          <Box
            w="100%"
            maxW={{ base: '100%', md: '520px', xl: '540px' }}
            mx="auto"
            bg={panelBg}
            border="1px solid"
            borderColor={panelBorder}
            borderRadius="32px"
            boxShadow="0 30px 80px rgba(34, 57, 124, 0.14)"
            backdropFilter="blur(20px)"
            p={{ base: '22px', md: '30px', xl: '34px' }}
          >
            {children}
          </Box>
        </Flex>

        <Footer />
      </Flex>

      <Box
        display={{ base: 'none', xl: 'block' }}
        flex="1"
        minH="100vh"
        p="28px"
      >
        <Flex
          position="relative"
          h="100%"
          borderRadius="36px"
          overflow="hidden"
          bg="linear-gradient(155deg, #0f182c 0%, #16203b 34%, #27356b 68%, #6f42c1 100%)"
          boxShadow="0 36px 100px rgba(17, 24, 39, 0.16)"
        >
          <Box
            position="absolute"
            inset="0"
            bg="radial-gradient(circle at 18% 18%, rgba(255,255,255,0.10), transparent 16%), radial-gradient(circle at 82% 84%, rgba(111, 66, 193, 0.42), transparent 26%), radial-gradient(circle at 74% 22%, rgba(13, 202, 240, 0.18), transparent 18%), radial-gradient(circle at 26% 78%, rgba(0, 204, 204, 0.12), transparent 20%)"
          />
          <Box
            position="absolute"
            top="-8%"
            left="-12%"
            w="72%"
            h="160px"
            transform="rotate(-20deg)"
            bg="linear-gradient(90deg, rgba(255,255,255,0.12), rgba(255,255,255,0.01))"
            filter="blur(8px)"
            opacity="0.42"
          />
          <Box
            position="absolute"
            right="-12%"
            bottom="-12%"
            w="340px"
            h="340px"
            borderRadius="full"
            bg="radial-gradient(circle, rgba(13, 202, 240, 0.18) 0%, rgba(13, 202, 240, 0) 70%)"
          />
          <Box
            position="absolute"
            top="22%"
            right="12%"
            w="280px"
            h="280px"
            borderRadius="full"
            border="1px solid rgba(255,255,255,0.08)"
            opacity="0.26"
          />
          <Box
            position="absolute"
            top="29%"
            right="19%"
            w="140px"
            h="140px"
            borderRadius="full"
            border="1px solid rgba(255,255,255,0.08)"
            opacity="0.22"
          />
          <Box position="absolute" inset="0" bg={heroOverlay} />
          <Stack
            position="relative"
            zIndex="1"
            spacing="7"
            justify="space-between"
            color="white"
            h="100%"
            maxW="540px"
            p="44px"
          >
            <Box>
              <Text
                fontSize="xs"
                letterSpacing="0.24em"
                textTransform="uppercase"
                opacity="0.78"
                mb="16px"
              >
                VIN Admin Portal
              </Text>
              <Heading
                fontFamily="'Urbanist', sans-serif"
                fontSize="clamp(2.5rem, 2.15rem + 1vw, 4.1rem)"
                lineHeight="0.96"
                fontWeight="800"
                letterSpacing="-0.04em"
                mb="18px"
              >
                Review faster, keep records tighter, and manage every inspection
                from one calm command center.
              </Heading>
              <Text
                fontSize="lg"
                color="rgba(255,255,255,0.84)"
                maxW="500px"
                lineHeight="1.8"
              >
                Built for super admins handling VIN history, required vehicle
                photos, and monthly inspection workflows with less friction.
              </Text>
            </Box>

            <Stack
              spacing="16px"
              borderRadius="30px"
              bg="linear-gradient(180deg, rgba(15, 24, 44, 0.42), rgba(22, 32, 59, 0.64))"
              border="1px solid rgba(255,255,255,0.10)"
              backdropFilter="blur(16px)"
              p="24px"
            >
              <HStack spacing="14px" align="flex-start">
                <Flex
                  align="center"
                  justify="center"
                  w="44px"
                  h="44px"
                  borderRadius="16px"
                  bg="rgba(255,255,255,0.10)"
                  flexShrink="0"
                >
                  <Icon as={MdOutlineDirectionsCar} boxSize="22px" />
                </Flex>
                <Box>
                  <Text fontWeight="800" fontSize="lg">
                    VIN-linked inspection records
                  </Text>
                  <Text color="rgba(255,255,255,0.78)" mt="4px">
                    Track each vehicle with its own detail view, image set, and
                    history trail.
                  </Text>
                </Box>
              </HStack>

              <HStack spacing="14px" align="flex-start">
                <Flex
                  align="center"
                  justify="center"
                  w="44px"
                  h="44px"
                  borderRadius="16px"
                  bg="rgba(255,255,255,0.10)"
                  flexShrink="0"
                >
                  <Icon as={MdOutlinePhotoLibrary} boxSize="22px" />
                </Flex>
                <Box>
                  <Text fontWeight="800" fontSize="lg">
                    Required and supporting photos
                  </Text>
                  <Text color="rgba(255,255,255,0.78)" mt="4px">
                    Manage front, left, right, back, and additional image
                    evidence in one flow.
                  </Text>
                </Box>
              </HStack>

              <HStack spacing="14px" align="flex-start">
                <Flex
                  align="center"
                  justify="center"
                  w="44px"
                  h="44px"
                  borderRadius="16px"
                  bg="rgba(255,255,255,0.10)"
                  flexShrink="0"
                >
                  <Icon as={MdOutlineFolderOpen} boxSize="22px" />
                </Flex>
                <Box>
                  <Text fontWeight="800" fontSize="lg">
                    Month-wise review workflow
                  </Text>
                  <Text color="rgba(255,255,255,0.78)" mt="4px">
                    Open inspections by month, filter faster, and keep admin
                    review cycles organized.
                  </Text>
                </Box>
              </HStack>
            </Stack>
          </Stack>
        </Flex>
      </Box>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  image: PropTypes.any,
};

export default AuthIllustration;
